import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './styles/style.css';
import { App } from './App.jsx';
import { installNativeBack } from './lib/nativeBack.js';
import { initChrome } from './hooks/useDarkChrome.js';

// 안드로이드 하드웨어 뒤로 가기(DEV-12): 껍데기가 window.__insaengBack 을 부름
installNativeBack();
// 앱 상태바: 새로 열린 페이지는 밝은 화면 바로 시작(어두운 시작 화면에서 넘어와도 흰 아이콘이 남지 않게)
initChrome();

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>
);
